var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoiceIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E2E6E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 22V24C31 27.866 27.866 31 24 31M17 22V24C17 27.866 20.134 31 24 31M24 31V34M20 34H28M24 27C22.3431 27 21 25.6569 21 24V17C21 15.3431 22.3431 14 24 14C25.6569 14 27 15.3431 27 17V24C27 25.6569 25.6569 27 24 27Z",
    stroke: "#101828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceIc);
export default __webpack_public_path__ + "static/media/voice_ic.724f0742.svg";
export { ForwardRef as ReactComponent };